import { styled } from "@vitality-ds/system";
import { BaseIconWrapper } from "./styles/BaseIconWrapper.styles";

// eslint-disable-next-line import/prefer-default-export
export var IconWrapper = styled("div", BaseIconWrapper);